import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import PlayingCard from "../../cmp/PlayingCard";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { CardHeight, DragCard } from "../../api/CardApi";
import {
  Hand,
  Pile,
  Stuck,
  Work,
  nertzPlayerMessage,
} from "../../api/NertzApi";
import CardSlot from "../../cmp/CardSlot";
import { useParams } from "react-router-dom";

const cardTypes = ["hand", "nertz", "work", "workPile"];

function NertzWorkPiles() {
  const params = useParams(),
    [work, setWork] = useRecoilState(Work),
    [pile, setPile] = useRecoilState(Pile),
    [hand, setHand] = useRecoilState(Hand),
    cardHeight = useRecoilValue(CardHeight),
    dragCard = useRecoilValue(DragCard),
    setStuck = useSetRecoilState(Stuck),
    handleOver = (e, i) => {
      if (dragCard && cardTypes.indexOf(dragCard.cardType) > -1) {
        const pile = work[i],
          card = pile[pile.length - 1];

        if (
          !card ||
          (card.rank - dragCard.rank === 1 &&
            card.suit % 2 !== dragCard.suit % 2)
        ) {
          e.preventDefault();
        }
      }
    },
    handleDrop = (e, i) => {
      const addCard = () => {
        setWork(
          work.map((w, index) =>
            i === index
              ? [
                  ...w,
                  {
                    rank: dragCard.rank,
                    suit: dragCard.suit,
                  },
                ]
              : w
          )
        );
      };

      switch (dragCard.cardType) {
        case "hand":
          addCard();
          setHand(hand.slice(0, -1));
          setStuck(false);
          break;
        case "nertz":
          addCard();
          setPile(pile.slice(1));
          setStuck(false);
          nertzPlayerMessage(params.id, {
            score: {
              nertz: 1,
              score: 2,
            },
          });
          break;
        case "work":
          setWork(
            work.map((w, index) =>
              i === index
                ? [
                    ...w,
                    {
                      rank: dragCard.rank,
                      suit: dragCard.suit,
                    },
                  ]
                : w.some(
                    (s) => s.rank === dragCard.rank && s.suit === dragCard.suit
                  )
                ? w.slice(0, -1)
                : w
            )
          );

          break;
        case "workPile":
          const piles = [work[0], work[1], work[2], work[3]];

          work.forEach((w, index) => {
            if (i !== index) {
              const fi = w.findIndex(
                (f) => f.rank === dragCard.rank && f.suit === dragCard.suit
              );

              if (fi > -1) {
                piles[i] = [...piles[i], ...w.slice(fi)];
                piles[index] = [...piles[index].slice(0, fi)];
              }
            }
          });

          setWork(piles);
          break;
        default:
          break;
      }

      e.preventDefault();
    };

  return (
    <Card
      id="nertz-work-piles"
      raised
      sx={{ display: "flex", flexDirection: "column" }}
    >
      <CardHeader title="My Work Piles" />
      <CardContent sx={{ height: (cardHeight * 15) / 4, overflow: "hidden" }}>
        <Stack id="nertz-ref-stack" direction="row" spacing={1}>
          {work.map((w, i) => (
            <Stack key={`workPile${i}`} spacing={`${cardHeight * -0.75}px`}>
              {w.length ? (
                w.map((c, j) => (
                  <PlayingCard
                    cardType={w.length - j === 1 ? "work" : "workPile"}
                    key={`workPile${i}Card${j}`}
                    {...c}
                    onDragOver={
                      w.length - j === 1
                        ? (e) => {
                            handleOver(e, i);
                          }
                        : null
                    }
                    onDrop={
                      w.length - j === 1
                        ? (e) => {
                            handleDrop(e, i);
                          }
                        : null
                    }
                  />
                ))
              ) : (
                <CardSlot
                  onDragOver={(e) => {
                    handleOver(e, i);
                  }}
                  onDrop={(e) => {
                    handleDrop(e, i);
                  }}
                />
              )}
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default NertzWorkPiles;
